export const GET_USER_TYPES_AND_FUNCTIONALITIES =
  'GET_USER_TYPES_AND_FUNCTIONALITIES'
